import { render } from "./IconsCTAV2.vue?vue&type=template&id=286ac143&scoped=true"
import script from "./IconsCTAV2.vue?vue&type=script&lang=js"
export * from "./IconsCTAV2.vue?vue&type=script&lang=js"

import "./IconsCTAV2.vue?vue&type=style&index=0&id=286ac143&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286ac143"]])

export default __exports__